import { render, staticRenderFns } from "./TabbedPortletBody.vue?vue&type=template&id=46058396&scoped=true&"
import script from "./TabbedPortletBody.vue?vue&type=script&lang=js&"
export * from "./TabbedPortletBody.vue?vue&type=script&lang=js&"
import style0 from "./TabbedPortletBody.vue?vue&type=style&index=0&id=46058396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46058396",
  null
  
)

export default component.exports